import { ROUTE } from "../../routes";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { api } from "../../configs/api";
import { APP_CONFIG, getAppHeader } from "../../configs/config";
import { DigioKycStatus, VOLT_ERROR_CODE } from "../../configs/constants";
import { nextStepCredStepper } from "../../configs/utils";
import _ from 'lodash';
import { WIDGET } from "@voltmoney/schema";
import SharedPropsService from "../../SharedPropsService";
let pollInterval;
let responseFromDigio;
let isPopupShown = false;
export const GoToNumber = async (action, _datastore, { navigate }) => {
    await AsyncStorage.setItem('first_time', 'true');
    navigate(ROUTE.SPLASH_SCREEN);
};
export const closeModal = async (action, _datastore, { goBack, navigate, navigateWithClear }) => {
    const intervalToClear = await SharedPropsService.getPollarInterval();
    intervalToClear &&
        clearInterval(intervalToClear);
    await navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
        showFailedModal: true,
        failedTitle: 'KYC verification canceled',
        failedSubTitle: 'KYC verification is required for the completion of your loan application',
        failedButtonTitle: 'Try again',
        clearPollar: true
    });
};
export const hidePopup = async (action, _datastore, { hidePopup }) => {
    hidePopup();
};
export const failedVerification = async (action, _datastore, { goBack, hidePopup }) => {
    goBack();
    await hidePopup();
};
export const successVerification = async (action, _datastore, { hidePopup, navigateWithClear, goBack }) => {
    isPopupShown = true;
    hidePopup();
    const routeObj = await nextStepCredStepper();
    await navigateWithClear(routeObj.routeId, routeObj.params);
};
export const cancelAction = async (action, _datastore, { goBack, showPopup }) => {
    goBack();
};
export const digioCallback = async (action, datastore, { network, showPopup, navigateWithClear, navigate, setDatastore, navigateToBase, goBack, removeWidgets }) => {
    responseFromDigio = action.payload;
    const type = action.payload.type;
    const error = action.payload.error;
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : userContextResponse.data.linkedApplications[0].applicationId;
    const pollFunction = async () => {
        network
            .get(`${api.digioKycCheckRequestStatusOnCallBackV2}${applicationId}`, {
            headers: await getAppHeader(),
            handleFromMF: true
        }, async () => {
            return;
        }, {
            disableDefault: true
        })
            .then(async (response) => {
            if (response.status === 200) {
                if (response.data.stepResponseObject ===
                    DigioKycStatus.COMPLETED && type === 'success') {
                    clearInterval(pollInterval);
                    navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                        showFailedModal: false,
                        showSuccessModal: true,
                        successTitle: 'KYC done successfully',
                        successSubTitle: 'KYC has been completed successfully',
                        successButtonTitle: 'Continue',
                        currentStepId: response?.data?.updatedApplicationObj?.currentStepId,
                        loading: true
                    });
                    return;
                }
                else if (response.data.stepResponseObject ===
                    DigioKycStatus.EXPIRED ||
                    response.data.stepResponseObject ===
                        DigioKycStatus.FAILED) {
                    clearInterval(pollInterval);
                    navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                        showFailedModal: true,
                        failedTitle: 'Something went wrong',
                        failedSubTitle: ' ',
                        failedButtonTitle: 'Try again'
                    });
                    return;
                }
                else if (error === 'user_cancelled') {
                    clearInterval(pollInterval);
                    navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                        showFailedModal: true,
                        failedTitle: 'KYC verification canceled',
                        failedSubTitle: 'KYC verification is required for the completion of your loan application',
                        failedButtonTitle: 'Try again'
                    });
                    return;
                }
            }
            else if (response?.response?.status === 400) {
                clearInterval(pollInterval);
                if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.DIGIO_PAN_MISMATCH) {
                    navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                        showFailedModal: true,
                        failedTitle: "Verification failed!",
                        failedSubTitle: `${response?.response?.data?.message}`,
                        failedButtonTitle: "Ok, got it.",
                        loading: true
                    });
                    return;
                }
                else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.PAN_AADHAAR_NOT_LINKED || response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.PAN_NOT_SEEDED) {
                    navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                        showFailedModal: true,
                        failedTitle: "PAN is not linked with the provided Aadhaar",
                        failedSubTitle: `${response?.response?.data?.message}`,
                        failedButtonTitle: "Ok, got it.",
                        loading: true
                    });
                    return;
                }
                else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.INVALID_PAN) {
                    navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                        showFailedModal: true,
                        failedTitle: "PAN is invalid",
                        failedSubTitle: `${response?.response?.data?.message}`,
                        failedButtonTitle: "Ok, got it.",
                        loading: true
                    });
                    return;
                }
                else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.MISMATCH_DETECTED) {
                    navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                        showFailedModal: true,
                        failedTitle: "PAN is not linked with the provided Aadhaar",
                        failedSubTitle: `${response?.response?.data?.message}`,
                        failedButtonTitle: "Ok, got it.",
                        loading: true
                    });
                    return;
                }
                else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.AGE_BELOW_LIMIT) {
                    navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                        showFailedModal: true,
                        failedTitle: "Minimum age requirement not met",
                        failedSubTitle: `${response?.response?.data?.message}`,
                        failedButtonTitle: "Ok, got it.",
                        loading: true
                    });
                    return;
                }
                else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.AGE_ABOVE_LIMIT) {
                    navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                        showFailedModal: true,
                        failedTitle: "Age eligibility criteria not met",
                        failedSubTitle: `${response?.response?.data?.message}`,
                        failedButtonTitle: "Ok, got it.",
                        loading: true
                    });
                    return;
                }
                const failureJson = JSON.parse(response.response.data.message);
                const errorCode = response.response.data.voltErrorCode;
                if (failureJson.failureType === "NAME_MISMATCH") {
                    const heading = failureJson.nameMatchFailureDetails.description;
                    const key1 = failureJson.nameMatchFailureDetails.source.description;
                    const value1 = failureJson.nameMatchFailureDetails.source.value;
                    const key2 = failureJson.nameMatchFailureDetails.target.description;
                    const value2 = failureJson.nameMatchFailureDetails.target.value;
                    await navigate(ROUTE.NAME_MISMATCH, {
                        heading: heading,
                        key1: key1,
                        value1: value1,
                        key2: key2,
                        value2: value2,
                        isFromKYC: true,
                        voltErrorCode: errorCode
                    });
                }
            }
            else if (error === 'user_cancelled') {
                clearInterval(pollInterval);
                navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                    showFailedModal: true,
                    failedTitle: 'KYC verification canceled',
                    failedSubTitle: 'KYC verification is required for the completion of your loan application',
                    failedButtonTitle: 'Try again',
                    loading: true
                });
                return;
            }
            else {
                clearInterval(pollInterval);
                if (_.get(response, 'response.status', false) === 400) {
                    if (_.get(response, 'response.data.voltErrorCode', false) === "DIGIO_PAN_MISMATCH") {
                        removeWidgets(ROUTE.DIGIO_MODAL, [
                            { id: "digio", type: WIDGET.KYC_DIGIO_MOBILE }
                        ]);
                        const errorMessage = _.get(response, 'response.data', false);
                        navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showFailedModal: true,
                            failedTitle: 'KYC Verification failed',
                            failedSubTitle: errorMessage.message,
                            failedButtonTitle: 'Try again',
                            loading: true
                        });
                        return;
                    }
                    else {
                        const errorCode = _.get(response, 'response.data.voltErrorCode', false);
                        const errorResponseData = _.get(response, 'response.data', false);
                        const failureType = errorResponseData.message;
                        const failureJson = JSON.parse(failureType);
                        if (failureJson.failureType === "NAME_MISMATCH") {
                            removeWidgets(ROUTE.DIGIO_MODAL, [
                                { id: "digio", type: WIDGET.KYC_DIGIO_MOBILE }
                            ]);
                            const heading = failureJson.nameMatchFailureDetails.description;
                            const key1 = failureJson.nameMatchFailureDetails.source.description;
                            const value1 = failureJson.nameMatchFailureDetails.source.value;
                            const key2 = failureJson.nameMatchFailureDetails.target.description;
                            const value2 = failureJson.nameMatchFailureDetails.target.value;
                            clearInterval(pollInterval);
                            await navigateToBase(ROUTE.NAME_MISMATCH, {
                                heading: heading,
                                key1: key1,
                                value1: value1,
                                key2: key2,
                                value2: value2,
                                isFromKYC: true,
                                voltErrorCode: errorCode
                            });
                        }
                    }
                }
            }
        });
    };
    await pollFunction();
    const pollInterval = setInterval(() => {
        pollFunction();
    }, APP_CONFIG.POLLING_INTERVAL);
};
export const navigateHandleAction = async (action, _datastore, { navigateWithClear }) => {
    const kycCancelled = action?.payload?.value === "KYC_CANCELLED";
    const kycClosePopup = action?.payload?.value === "KYC_POPUP_CLOSED";
    if (kycCancelled) {
        navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
            showFailedModal: true,
            failedTitle: 'KYC Verification cancelled',
            failedSubTitle: "KYC verification is required for the completion of your loan application",
            failedButtonTitle: 'Try again',
            showCancelledModal: true,
            loading: true
        });
    }
    else if (kycClosePopup) {
        navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
            showFailedModal: false,
            failedTitle: 'KYC Verification cancelled',
            failedSubTitle: "KYC verification is required for the completion of your loan application",
            failedButtonTitle: 'Try again',
            showCancelledModal: true,
            loading: true
        });
    }
};
